import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import vuetwemoji from 'vue-twemoji'
import TreeView from "vue-json-tree-view"
import VueAnalytics from 'vue-analytics'

import HelperPlugin from './plugins/helper'

Vue.config.productionTip = false

Vue.use(HelperPlugin)
Vue.use(TreeView)

Vue.use(vuetwemoji, {
  baseUrl: 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/',
  extension: '.png', //.svg, .png
  className: 'emoji', //custom className for image output
  size: '72x72' //image size
})

if (process.env.NODE_ENV === 'production') {
  console.log('Use Google analytics...')
  Vue.use(VueAnalytics, {
    id: 'G-Q3HBZYX272',
    router
  })
}

new Vue({
  router,
  store,
  vuetify,
  beforeCreate() { this.$store.commit('config/initialiseConfig') },
  render: h => h(App)
}).$mount('#app')
